import React from 'react';
import LocationTemplate from './LocationTemplate';

const LillingtonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Lillington"
      stateName="North Carolina"
      countyName="Harnett"
      zipCodes={["27546"]}
      latitude={35.3951}
      longitude={-78.8151}
      population={3967}
      historicalFact="County seat of Harnett County, established in 1859 and named after Revolutionary War General Alexander Lillington."
      nearbyTowns={[
        "Fuquay-Varina, NC",
        "Angier, NC",
        "Dunn, NC",
        "Coats, NC",
        "Erwin, NC",
        "Buies Creek, NC",
        "Holly Springs, NC",
        "Apex, NC"
      ]}
    />
  );
};

export default LillingtonPage;